import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

interface Props {
  open: boolean;
  reason: "expired" | "unauthorized" | null;
  onConfirm: () => void;
}

export function SessionExpiredDialog({ open, reason, onConfirm }: Props) {
  const title = reason === "unauthorized" ? "Session invalide" : "Session expirée";
  const description = reason === "unauthorized"
    ? "Votre session n'est plus valide. Veuillez vous reconnecter pour continuer."
    : "Vous êtes resté inactif trop longtemps et votre session a expiré. Pour des raisons de sécurité, vous devez vous reconnecter.";

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onConfirm}>Se reconnecter</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
